<div *ngIf="(this.mls.featureOnOffList.moduleList.CALENDAR.value || !mls.userLoginFlow)">
<div class="clndr-event-wrapper">
  <div [ngClass]="(callingfrom !== 'suggestionRight')  ? 'container-shadow bg-white' : 'top-radius' ">
  <div class="clndar-actions" [ngClass]="(callingfrom !== 'suggestionRight')  ? ' ' : 'top-radius bg-white' ">
    <div class="row text-center  align-items-center">
      <div class="col-2 p-0">
        <div
          mwlCalendarPreviousView
          [view]="view"
          [(viewDate)]="dss.viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          <img class="cursor-pointer" src="assets/themes/icons/calendarbackward.svg" alt="backward" />
        </div>
      </div>
      <div class="col-8">
        <div mwlCalendarToday [(viewDate)]="dss.viewDate">
          <p><span class="heading-4">
            {{ dss.viewDate | calendarDate : view + "ViewTitle" : "en" }}</span>
          </p>
        </div>
      </div>
      <div class="col-2 p-0">
        <div
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="dss.viewDate"
          (viewDateChange)="closeOpenMonthViewDay()">
          <img class="cursor-pointer" src="assets/themes/icons/calendarforward.svg" alt="forward" />
        </div>
      </div>
    </div>
  </div>
  <div
    [ngSwitch]="view"
    class="calendar-container light"
    [ngClass]="{ gndround: callingfrom === 'suggestionRight' }">
    <mwl-calendar-month-view
      *ngSwitchCase="CalendarView.Month"
      [viewDate]="dss.viewDate"
      [events]="events"
      [activeDayIsOpen]="activeDayIsOpen"
      [refresh]="refresh"
      (dayClicked)="dayClicked($event.day)">
    </mwl-calendar-month-view>
  </div>
</div>
 <div>
  <div class="position-left" [ngClass]="(callingfrom !== 'suggestionRight')  ? 'vt-tabs mt-4' : 'hz-tabs p-0 ' " >
  <ul
    class="bg-white tab-items mb-0 pl-0"
    [ngClass]="(callingfrom !== 'suggestionRight') ? 'container-shadow py-1' : 'filter-list gndround' ">
    <li class="text-left" [ngClass]="(callingfrom !== 'suggestionRight')  ? 'pl-0' : 'pl-1' ">
      <input
        class="d-none"
        id="all"
        type="radio"
        name="list-for"
        [checked]="true"
        (change)="onItemChange(0,'All')"/>
      <label class="label-text cursor-pointer" [ngClass]="{'active':productType===0}" for="all"><span [ngClass]="callingfrom !== 'suggestionRight' ? 'heading-4 ' : ' secondary-paragraph ' ">
        <span [ngClass]="productType===0 ? 'color-black' : 'color-grey-500'"> 
          {{mls.languageText.calendar_fullView_title.key1}}
      </span></span></label>
    </li>
    <li class="text-left pl-0">
      <input
      class="d-none"
        id="my-meeting"
        type="radio"
        name="list-for"
        (change)="onItemChange(41, 'My Meetings')"/>
      <label class="label-text cursor-pointer" [ngClass]="{'active':productType===41}" for="my-meeting"><span  [ngClass]="callingfrom !== 'suggestionRight' ? 'heading-4 ' : ' secondary-paragraph ' ">
        <span [ngClass]="productType===41 ? 'color-black' : 'color-grey-500' ">
          {{mls.languageText.calendar_fullView_title.key2}}
      </span></span></label>
    </li>
    <li class="text-left pl-0">
      <input
      class="d-none"
        id="webinars"
        type="radio"
        name="list-for"
        (change)="onItemChange(27, 'Webinars')"/>
      <label class="label-text cursor-pointer" [ngClass]="{'active':productType===27}" for="webinars"><span  [ngClass]="callingfrom !== 'suggestionRight' ? 'heading-4 ' : ' secondary-paragraph' ">
        <span [ngClass]="productType===27 ? 'color-black' : 'color-grey-500' ">
          {{mls.languageText.calendar_fullView_title.key3}}
      </span></span></label>
    </li>
    <li class="text-left pl-0">
      <input
      class="d-none"
        id="events"
        type="radio"
        name="list-for"
        (change)="onItemChange(7, 'Events')"/>
      <label class="label-text cursor-pointer" [ngClass]="{'active':productType===7}" for="events"><span  [ngClass]="callingfrom !== 'suggestionRight' ? 'heading-4 ' : ' secondary-paragraph ' ">
        <span [ngClass]="productType===7 ? 'color-black' : 'color-grey-500' ">
          {{ mls.languageText.calendar_fullView_title.key4}}
      </span></span></label>
    </li>
  </ul>
  </div>
 </div>
</div>
</div>